import React, { useEffect, useState } from 'react';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';
import { supabase } from '../../lib/supabase';

export const BlogPage: React.FC = () => {
  const [pageData, setPageData] = useState<any>(null);
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Fetch page data
      const { data: page, error: pageError } = await supabase
        .from('pages')
        .select('*')
        .eq('slug', 'blog')
        .eq('is_published', true)
        .single();

      if (pageError) throw pageError;
      if (page) {
        setPageData(page);
      }

      // Fetch blog posts
      const { data: postsData, error: postsError } = await supabase
        .from('posts')
        .select('*')
        .eq('is_published', true)
        .order('created_at', { ascending: false });

      if (postsError) throw postsError;
      if (postsData) {
        setPosts(postsData);
      }
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#C1121F]"></div>
      </div>
    );
  }

  const featuredPost = {
    id: 1,
    title: 'CNC Tornalama İpuçları: Hassas İşleme Teknikleri',
    slug: 'cnc-tornalama-ipuclari-hassas-isleme-teknikleri',
    excerpt: 'CNC torna tezgahlarında mikron hassasiyetinde işleme için önemli ipuçları ve teknikler. Takım seçiminden kesme parametrelerine kadar detaylı rehber.',
    content: 'CNC tornalama, modern imalat sanayinin en önemli işleme yöntemlerinden biridir...',
    author: 'Mehmet Yılmaz',
    authorRole: 'CNC Uzmanı',
    publishDate: '15 Mart 2024',
    readTime: '8 dakika',
    category: 'CNC İşleme',
    tags: ['CNC Torna', 'Hassas İşleme', 'Takım Seçimi', 'Kalite Kontrol'],
    image: 'https://public.readdy.ai/ai/img_res/ace0bf9a9247171c9adc34299d0da20f.jpg',
    featured: true
  };

  const blogPosts = [
    {
      id: 2,
      title: '3D Baskı mı İşleme mi? Prototipleme İçin Doğru Seçim',
      slug: '3d-baski-mi-isleme-mi-prototipleme-icin-dogru-secim',
      excerpt: 'Prototip üretiminde 3D baskı ve geleneksel işleme yöntemlerinin karşılaştırması. Hangi durumda hangi yöntemi tercih etmelisiniz?',
      author: 'Oğuz Çelik',
      authorRole: '3D Tasarım Uzmanı',
      publishDate: '12 Mart 2024',
      readTime: '6 dakika',
      category: '3D Baskı',
      tags: ['3D Baskı', 'Prototipleme', 'Maliyet Analizi'],
      image: 'https://readdy.ai/api/search-image?query=3D%20printer%20and%20CNC%20machine%20comparison%20for%20prototyping%2C%20modern%20Turkish%20workshop%2C%20red%20and%20white%20theme%2C%20technical%20comparison&width=400&height=250&seq=3d-vs-cnc&orientation=landscape'
    },
    {
      id: 3,
      title: 'Kaynak Sonrası Muayene Yöntemleri ve Kalite Kontrol',
      slug: 'kaynak-sonrasi-muayene-yontemleri-ve-kalite-kontrol',
      excerpt: 'Kaynak işlemi sonrasında uygulanması gereken muayene yöntemleri ve kalite kontrol süreçleri hakkında detaylı bilgiler.',
      author: 'Ahmet Kaya',
      authorRole: 'Kaynak Uzmanı',
      publishDate: '10 Mart 2024',
      readTime: '10 dakika',
      category: 'Kaynak',
      tags: ['Kaynak', 'Kalite Kontrol', 'NDT', 'Muayene'],
      image: 'https://readdy.ai/api/search-image?query=Welding%20quality%20inspection%20with%20NDT%20testing%20equipment%2C%20Turkish%20workshop%2C%20red%20and%20white%20industrial%20lighting%2C%20quality%20control%20process&width=400&height=250&seq=welding-inspection&orientation=landscape'
    },
    {
      id: 4,
      title: 'CNC Freze İşlemlerinde Takım Seçimi ve Optimizasyon',
      slug: 'cnc-freze-islemlerinde-takim-secimi-ve-optimizasyon',
      excerpt: 'CNC freze tezgahlarında doğru takım seçimi ve kesme parametrelerinin optimizasyonu için pratik öneriler.',
      author: 'Mehmet Yılmaz',
      authorRole: 'CNC Uzmanı',
      publishDate: '8 Mart 2024',
      readTime: '7 dakika',
      category: 'CNC İşleme',
      tags: ['CNC Freze', 'Takım Seçimi', 'Optimizasyon'],
      image: 'https://readdy.ai/api/search-image?query=CNC%20milling%20tools%20and%20cutting%20parameters%20optimization%2C%20Turkish%20machining%20center%2C%20red%20accent%20lighting%2C%20technical%20tools%20display&width=400&height=250&seq=milling-tools&orientation=landscape'
    },
    {
      id: 5,
      title: 'Alüminyum Kaynak Teknikleri: TIG ve MIG Karşılaştırması',
      slug: 'aluminyum-kaynak-teknikleri-tig-ve-mig-karsilastirmasi',
      excerpt: 'Alüminyum malzemelerin kaynağında TIG ve MIG yöntemlerinin avantajları, dezavantajları ve uygulama alanları.',
      author: 'Ahmet Kaya',
      authorRole: 'Kaynak Uzmanı',
      publishDate: '5 Mart 2024',
      readTime: '9 dakika',
      category: 'Kaynak',
      tags: ['Alüminyum', 'TIG Kaynak', 'MIG Kaynak'],
      image: 'https://readdy.ai/api/search-image?query=Aluminum%20welding%20comparison%20TIG%20vs%20MIG%20techniques%2C%20professional%20Turkish%20welder%2C%20red%20and%20white%20workshop%20lighting&width=400&height=250&seq=aluminum-welding&orientation=landscape'
    },
    {
      id: 6,
      title: 'Koordinat Ölçüm Makinesi (CMM) ile Hassas Ölçüm',
      slug: 'koordinat-olcum-makinesi-cmm-ile-hassas-olcum',
      excerpt: 'CMM koordinat ölçüm makinelerinin kullanımı, avantajları ve hassas ölçüm teknikleri hakkında kapsamlı rehber.',
      author: 'Fatma Demir',
      authorRole: 'Kalite Kontrol Uzmanı',
      publishDate: '2 Mart 2024',
      readTime: '8 dakika',
      category: 'Kalite Kontrol',
      tags: ['CMM', 'Hassas Ölçüm', 'Kalite Kontrol'],
      image: 'https://readdy.ai/api/search-image?query=CMM%20coordinate%20measuring%20machine%20in%20quality%20control%20lab%2C%20precision%20measurement%2C%20Turkish%20facility%20with%20red%20and%20white%20lighting&width=400&height=250&seq=cmm-measurement&orientation=landscape'
    }
  ];

  const categories = [
    { name: 'Tümü', count: 6, active: true },
    { name: 'CNC İşleme', count: 2, active: false },
    { name: 'Kaynak', count: 2, active: false },
    { name: '3D Baskı', count: 1, active: false },
    { name: 'Kalite Kontrol', count: 1, active: false }
  ];

  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "3DP Makina Teknik Blog",
    "description": "CNC işleme, kaynak teknikleri, 3D baskı ve kalite kontrol konularında uzman görüşleri ve pratik bilgiler.",
    "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/blog`,
    "publisher": {
      "@type": "Organization",
      "name": "3DP Makina",
      "logo": {
        "@type": "ImageObject",
        "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/logo.png`
      }
    },
    "blogPost": blogPosts.map(post => ({
      "@type": "BlogPosting",
      "headline": post.title,
      "description": post.excerpt,
      "author": {
        "@type": "Person",
        "name": post.author
      },
      "datePublished": post.publishDate,
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/blog/${post.slug}`
    }))
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Teknik Blog | CNC, Kaynak, 3D Baskı Uzman Yazıları"
        description="CNC işleme, kaynak teknikleri, 3D baskı ve kalite kontrol konularında uzman görüşleri ve pratik bilgiler. Sektörel deneyimlerimizi paylaşıyoruz."
        keywords="CNC blog, kaynak teknikleri, 3D baskı, kalite kontrol, teknik yazılar, imalat"
        canonical={`${import.meta.env.VITE_SITE_URL || "https://example.com"}/blog`}
        ogTitle="Teknik Blog | CNC, Kaynak, 3D Baskı Uzman Yazıları"
        ogDescription="CNC işleme, kaynak teknikleri, 3D baskı ve kalite kontrol konularında uzman görüşleri ve pratik bilgiler."
        ogUrl={`${import.meta.env.VITE_SITE_URL || "https://example.com"}/blog`}
        jsonLd={blogSchema}
      />
      {/* Hero Section */}
      <section 
        className="relative h-96 bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(22, 22, 22, 0.7), rgba(22, 22, 22, 0.7)), url('https://readdy.ai/api/search-image?query=Technical%20blog%20and%20knowledge%20sharing%20in%20Turkish%20manufacturing%20workshop%2C%20CNC%20machines%20and%20welding%20equipment%2C%20red%20and%20white%20industrial%20theme&width=1920&height=600&seq=blog-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-3xl text-white">
            <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Teknik Blog
            </h1>
            <p className="text-xl leading-relaxed">
              CNC işleme, kaynak teknikleri, 3D baskı ve kalite kontrol konularında 
              uzman görüşleri ve pratik bilgiler. Sektörel deneyimlerimizi paylaşıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                  category.active
                    ? 'bg-[#C1121F] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#161616] mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Öne Çıkan Yazı
            </h2>
          </div>

          <Card hover className="overflow-hidden max-w-4xl mx-auto">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/2">
                <img 
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="w-full h-64 lg:h-full object-cover object-top"
                />
              </div>
              <div className="lg:w-1/2 p-8">
                <div className="flex items-center mb-4">
                  <span className="bg-[#C1121F] text-white px-3 py-1 rounded-full text-sm font-medium mr-3">
                    {featuredPost.category}
                  </span>
                  <span className="text-gray-500 text-sm">
                    {featuredPost.readTime} okuma
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-[#161616] mb-4">
                  {featuredPost.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {featuredPost.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-gray-200 rounded-full mr-3"></div>
                    <div>
                      <div className="font-medium text-gray-700">{featuredPost.author}</div>
                      <div className="text-sm text-gray-500">{featuredPost.authorRole}</div>
                    </div>
                  </div>
                  <div className="text-sm text-gray-500">
                    {featuredPost.publishDate}
                  </div>
                </div>
                <div className="mt-6">
                  <Link to={`/blog/${featuredPost.slug}`}>
                    <Button variant="primary">
                      <i className="ri-arrow-right-line mr-2"></i>
                      Devamını Oku
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#161616] mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Son Yazılar
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <Card key={post.id} hover className="overflow-hidden">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm font-medium">
                      {post.category}
                    </span>
                    <span className="text-gray-500 text-sm">
                      {post.readTime}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-[#161616] mb-3">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-gray-200 rounded-full mr-2"></div>
                      <div>
                        <div className="text-sm font-medium text-gray-700">{post.author}</div>
                        <div className="text-xs text-gray-500">{post.authorRole}</div>
                      </div>
                    </div>
                    <div className="text-xs text-gray-500">
                      {post.publishDate}
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {post.tags.slice(0, 2).map((tag, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="text-center">
                    <Link to={`/blog/${post.slug}`}>
                      <Button variant="outline" size="sm" className="w-full">
                        <i className="ri-arrow-right-line mr-2"></i>
                        Devamını Oku
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Show More Button */}
          <div className="text-center mt-12">
            <Button variant="primary" size="lg">
              <i className="ri-add-line mr-2"></i>
              Tüm Yazıları Göster
            </Button>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-[#161616] mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Teknik İçerikleri Kaçırmayın
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Yeni blog yazılarımız ve sektörel gelişmeler hakkında bilgi almak için 
              e-posta listemize katılın.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C1121F] focus:border-transparent"
              />
              <Button variant="primary">
                <i className="ri-mail-line mr-2"></i>
                Abone Ol
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#C1121F]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Teknik Sorularınız mı Var?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Blog yazılarımızda bulamadığınız konular için uzman ekibimizle iletişime geçin.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/iletisim">
              <Button variant="secondary" size="lg">
                <i className="ri-question-line mr-2"></i>
                Teknik Destek Al
              </Button>
            </Link>
            <Link to="/teklif-al">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-[#C1121F]">
                <i className="ri-file-upload-line mr-2"></i>
                Proje Danışmanlığı
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
